import { Component, Input } from '@angular/core';
import { GuestKpiSnapshot } from '../marketing-dashboard.models';

@Component({
	selector: 'app-guest-tab',
	templateUrl: './guest-tab.component.html',
	styleUrls: ['./guest-tab.component.scss'],
	standalone: false
})
export class GuestTabComponent {

	@Input() snapshot: GuestKpiSnapshot | null = null;
}
